export default "__VITE_ASSET__V$GXhbP1__"